import React, { FunctionComponent, useMemo } from 'react';
import { GeolocationManager } from 'record-it-utils/location/GeolocationManager/GeolocationManager';
import { GeolocationManagerStrategy } from 'record-it-utils/location/GeolocationManager/strategy/GeolocationManagerStrategy';
import { GeolocationManagerGeolocationApiStrategy } from 'record-it-utils/location/GeolocationManager/strategy/GeolocationManagerGeolocationApiStrategy';
import {
  GeolocationManagerContext,
  GeolocationManagerContextValue
} from '../../context/GeolocationManagerContext';
import { prepareProps } from '../../utils/propUtils';

export type GeolocationManagerContextProviderProps = {
  overrideStrategy?: GeolocationManagerStrategy;
};

export const GeolocationManagerContextProvider: FunctionComponent<GeolocationManagerContextProviderProps> =
  React.memo((props) => {
    const { overrideStrategy, children } = prepareProps({ props });

    const contextValue = useMemo<GeolocationManagerContextValue>(() => {
      return {
        manager: new GeolocationManager(
          overrideStrategy ?? new GeolocationManagerGeolocationApiStrategy()
        )
      };
    }, [overrideStrategy]);

    return (
      <GeolocationManagerContext.Provider value={contextValue}>
        {children}
      </GeolocationManagerContext.Provider>
    );
  });
